import { render, staticRenderFns } from "./setPhone.vue?vue&type=template&id=75d9539f&scoped=true"
import script from "./setPhone.vue?vue&type=script&lang=js"
export * from "./setPhone.vue?vue&type=script&lang=js"
import style0 from "./setPhone.vue?vue&type=style&index=0&id=75d9539f&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75d9539f",
  null
  
)

export default component.exports